import styled from "styled-components/macro"

export const EditIconWrap = styled.div`
  position: absolute;
  right: 0;
  top: 0;
`
